export type Platform = 'Windows' | 'Mac' | 'Linux' | 'Android' | 'iOS';

/**
 * Получение названия операционной системы/платформы
 * @returns platformName - название операционной системы/платформы
 */
export function getCurrentPlatform() {
    const userAgent = typeof window !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
    let platformName: Platform | undefined = undefined;

    if (userAgent.match(/mac/i)) {
        platformName = 'Mac';
    } else if (userAgent.match(/win/i)) {
        platformName = 'Windows';
    } else if (userAgent.match(/linux/i)) {
        platformName = 'Linux';
    } else if (userAgent.match(/android/i)) {
        platformName = 'Android';
    } else if (userAgent.match(/iphone|ipad|ipod/i)) {
        platformName = 'iOS';
    }

    return platformName;
}
